import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { Badge } from "@/components/ui/badge";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Users } from "lucide-react";

export function TeamWorkloadView() {
  // Mock data - would come from useReviewerCapabilities
  const reviewers = [
    { id: "1", name: "Sarah Johnson", assigned: 8, capacity: 10, accuracy: 96, status: "online" },
    { id: "2", name: "Mike Chen", assigned: 7, capacity: 10, accuracy: 94, status: "online" },
    { id: "3", name: "Emma Davis", assigned: 10, capacity: 10, accuracy: 98, status: "busy" },
    { id: "4", name: "James Wilson", assigned: 5, capacity: 10, accuracy: 92, status: "online" },
    { id: "5", name: "Lisa Anderson", assigned: 6, capacity: 10, accuracy: 95, status: "away" },
  ];

  const getInitials = (name: string) => {
    return name.split(" ").map(n => n[0]).join("");
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case "online": return "bg-green-500";
      case "busy": return "bg-red-500";
      case "away": return "bg-yellow-500";
      default: return "bg-gray-500";
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Users className="h-5 w-5" />
          Team Workload Overview
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {reviewers.map((reviewer) => {
          const workload = (reviewer.assigned / reviewer.capacity) * 100;
          
          return (
            <div key={reviewer.id} className="space-y-2">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="relative">
                    <Avatar>
                      <AvatarFallback>{getInitials(reviewer.name)}</AvatarFallback>
                    </Avatar>
                    <span className={`absolute bottom-0 right-0 w-3 h-3 rounded-full border-2 border-background ${getStatusColor(reviewer.status)}`} />
                  </div>
                  <div>
                    <p className="font-medium">{reviewer.name}</p>
                    <p className="text-xs text-muted-foreground">
                      {reviewer.assigned} / {reviewer.capacity} assigned
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <Badge variant="outline" className="border-green-500 text-green-500">
                    {reviewer.accuracy}% accuracy
                  </Badge>
                  <Badge 
                    variant={workload >= 90 ? "destructive" : workload >= 70 ? "secondary" : "outline"}
                  >
                    {workload.toFixed(0)}%
                  </Badge>
                </div>
              </div>
              <Progress value={workload} className="h-2" />
            </div>
          );
        })}

        <div className="pt-4 border-t">
          <div className="flex justify-between text-sm">
            <span className="text-muted-foreground">Team Average Workload:</span>
            <span className="font-medium">72%</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
